import React from 'react';


export class ContentPagePreloader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={"tool__content__wrapper"}>

                <p style={{"text-align":"center","margin-top":"45vh"}}>Even geduld AUB, alle gegevens worden ingeladen</p>


            </div>

        );
    }

}
